import { z } from "zod";

export const FileExtractionOutputFormatSchema = z.enum(["csv", "json"]);
export type FileExtractionOutputFormat = z.infer<
  typeof FileExtractionOutputFormatSchema
>;

export const FILE_EXTRACTION_OCR_SOURCE = "file_extraction_tool" as const;
